import { BorderRadius, Color, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ViewSettingsContainer = styled.div`
  ${getShadow('raisedStrong')}
  width: 100%;
  padding: ${Spacing.S16};
  border-radius: ${BorderRadius.R12};
  background-color: ${Color.White};
`
